import { ArrowLeft, SearchX } from "lucide-react";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <main className="grid min-h-screen place-items-center bg-[#f8fbf8] px-5">
      <div className="surface max-w-lg p-10 text-center"><span className="mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-brand-50 text-brand-700"><SearchX size={28} /></span><p className="mt-6 text-xs font-black uppercase tracking-[0.18em] text-brand-700">404</p><h1 className="mt-2 text-3xl font-black tracking-[-0.04em] text-slate-900">Halaman tidak ditemukan</h1><p className="mt-3 text-sm leading-6 text-slate-500">Alamat yang kamu buka tidak tersedia atau sudah dipindahkan.</p><Link to="/" className="btn-primary mt-7"><ArrowLeft size={17} /> Kembali ke beranda</Link></div>
    </main>
  );
}
